import QRCode from "qrcode";
import { getClassMemberPdfDisplayUrl, getClassMemberUrl } from "../helpers/schoolClassHelpers";

export interface DownloadCodesClassMember {
    name: string;
    loginCode: string;
}

export interface DownloadCodesClassMemberWithQR extends DownloadCodesClassMember {
    qrCodeDataUrl: string;
    classMemberUrl: string;
    displayUrl: string;
}

const generateQRCodes = async (
    classMembers: DownloadCodesClassMember[],
    schoolClassId: string
): Promise<DownloadCodesClassMemberWithQR[]> => {
    return Promise.all(
        classMembers.map(async (classMember) => {
            const classMemberUrl = getClassMemberUrl(schoolClassId, classMember.loginCode);
            const displayUrl = getClassMemberPdfDisplayUrl(schoolClassId, classMember.loginCode);
            const qrCodeDataUrl = await QRCode.toDataURL(classMemberUrl, {
                width: 200,
                margin: 1,
            });
            return { ...classMember, qrCodeDataUrl, classMemberUrl, displayUrl };
        })
    );
};

export default generateQRCodes;
